<template>
    <th scope='col' class='tableHeader'>
        <input type="checkbox" v-if='columnHeaderValue.name == "checkAll"' :id='columnHeaderValue.name' :name='columnHeaderValue.name' value='all'>
        <span class='headerName' v-if='columnHeaderValue.name != "checkAll"'>{{columnHeaderValue.name}}
            <a @click.prevent='openTableMenu'>
                <DownChevronIcon />
            </a>
        </span>
        <div class='TableActions' v-if='showMenu && this.activeMenu == this.columnHeaderValue.name'>
            <ul class=ActionList>
                <li><span>Sort Ascending</span></li>
                <li><span>Sort Descending</span></li>
                <li><span>Specific Filter / Text Field</span></li>
                <li><span>Filters</span></li>
            </ul>
        </div>
    </th>
</template>

<script>
import DownChevronIcon from '../../icons/DownChevronIcon';

export default{
    name:'TableHead',
    props:['columnHeader'],
    components:{
        DownChevronIcon
    },
    data() {
        return{
            showMenu:false,
            columnHeaderValue: this.$props.columnHeader,
            activeMenu:''
        }
    },
    methods:{
        openTableMenu(e){
            this.showMenu = !this.showMenu
            this.activeMenu = this.columnHeaderValue.name
            console.log(this.columnHeaderValue.name);
        }
    }
}
</script>